module.exports = __webpack_public_path__ + "static/media/21.c2dc38b5.svg";